import { GlobalAppState } from '@model/state';

export const getDestination = (state: GlobalAppState) => state.app.destination;
